module.exports = __webpack_public_path__ + "img/jnsxpt.71d083cd.png";